// extracted by mini-css-extract-plugin
export default {"item":"CategoryList_item__R0inz","add":"CategoryList_add__ElrBb","icon":"CategoryList_icon__4VgDB","wrapper":"CategoryList_wrapper__0yKWz","round":"CategoryList_round__oWZWr"};